import React from 'react';
import { useAppContext } from '../../../context/AppContext';
import {
  calculateYearSpecificTotals,
  formatYearSpecificDisplay,
  getCurrentYear,
  calculatePreviousYearRevenueForYear
} from '../../../utils/yearSpecificUtils';

const PinnedListHeader = ({
  portfolioType,
  activeManager,
  isHardPinned,
  pinnedClients,
  calculateTotalRevenue
}) => {
  // Get full client data and selected year from context for year-specific calculations
  const { clientData, filters: { selectedYear } } = useAppContext();

  // Use selected year from History Mode, or current year if "All" is selected
  const currentYear = getCurrentYear();
  const displayYear = selectedYear !== 'All' ? selectedYear : currentYear;

  // Calculate year-specific totals for the selected manager and year
  const yearSpecificTotals = calculateYearSpecificTotals(clientData, activeManager, displayYear);
  const displayData = formatYearSpecificDisplay(yearSpecificTotals, activeManager);

  // Extract available years from clientData (scan all keys for "YYYY Revenue")
  const availableYearsSet = new Set();
  clientData.forEach(client => {
    Object.keys(client).forEach(key => {
      const match = key.match(/^(\d{4}) Revenue$/);
      if (match) {
        availableYearsSet.add(match[1]);
      }
    });
  });
  const availableYears = Array.from(availableYearsSet).sort();

  // Get only the manager's clients for previous year revenue calculation
  const managerClients = clientData.filter(client =>
    client.conference_manager === activeManager
  );

  // Calculate previous year revenue for the selected year
  const previousYearRevenue = calculatePreviousYearRevenueForYear(
    managerClients,
    selectedYear,
    availableYears
  );

  return (
    <div className="title-with-total">
      <h2>
        {portfolioType === 'manager' && activeManager
          ? (
            <>
              {isHardPinned
                ? <>{activeManager}: Client Portfolio <span className="editing-mode">(Editing Mode)</span></>
                : <>{activeManager}: Client Portfolio</>
              }
            </>
          )
          : <>Custom Portfolio</>
        }
      </h2>
      {pinnedClients.length > 0 && portfolioType === 'manager' && activeManager && (
        <div className="year-specific-data">
          <span className="year-label">{displayYear} Data:</span>
          <span className="year-metrics">
            {yearSpecificTotals.rooms} Rooms • Goal: {yearSpecificTotals.salesGoal}
          </span>
        </div>
      )}
    </div>
  );
};

export default PinnedListHeader;
